import React from "react";
import { FilterLabelProps, DateFromToFilter } from "@duosoftbg/nacid-components";

const ApplicationDateFilter = ({ label = "l.searchFilter.applicationDate", ...others }: FilterLabelProps) => {
  return (
    <>
      <DateFromToFilter label={label} from={`applicationDateFrom`} to={`applicationDateTo`} {...others} />
    </>
  );
};

export default ApplicationDateFilter;
